import { Outlet, RouteObject } from 'react-router'
import React from 'react'
import { PageLayout } from '@/common/layouts/PageLayout.tsx'
import { Spin, Tabs, Typography } from 'antd'
import { StaffCostImportExport } from '@/pages/staff-cost/staff-cost-import-export.tsx'
import { StaffCostReportDownload } from '@/pages/staff-cost/staff-cost-report-download.tsx'
import { PageTitle } from '@/common/components/PageTitle.tsx'

const StaffCostPage: React.FC = () => {
  return (
    <PageLayout className="h-full">
      <PageTitle value="Staff Cost" />
      <Spin spinning={false} fullscreen />
      <Typography.Title level={2}>Staff Cost</Typography.Title>
      <Tabs
        defaultActiveKey="dataImportExport" items={[
        {
          key: 'dataImportExport',
          label: 'Data Import/Export',
          children: <StaffCostImportExport />,
        },
        {
          key: 'reportDownload',
          label: 'Report Download',
          children: <StaffCostReportDownload />,
        },
      ]}
      />
    </PageLayout>
  )
}


export const staffCostRoutes: RouteObject = {
  path: 'staff-cost',
  element: <Outlet />,
  children: [
    { index: true, element: <StaffCostPage /> },
  ],
}